import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";
import Button from '../../../containers/Form/Button';

import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_lp_dashboard_stats, tool_lp_dashboard_data } from "../../../app/apiEndpoints" //tool_lp_dashboard_boost
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, FormGroup, FormLabel, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'

import { CSVLink } from "react-csv";
import CascadeToolToggle from '../../../containers/CascadeToolToggle';

const sortPids = (pids) => {
    return [...pids].sort((a, b) => {
        // Keep a "view all" placeholder (empty ID) pinned to the top
        if (a.ID === '' || a.ID === '0') return -1;
        if (b.ID === '' || b.ID === '0') return 1;
        return String(a.NAME).localeCompare(String(b.NAME), undefined, { sensitivity: 'base' });
    });
}

const LanderDashboard = (props) => {
    const toolID = 10
    const [tool, setTool] = useState({})

    const [cascadeType, setCascadeType] = useState(0)

    //const [hasErrors, setHasErrors] = useState(false)
    //const [status, setStatus] = useState(0)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [revStats, setRevStats] = useState([])
    const [blacklistStats, setBlacklistStats] = useState([])
    //const [revSuccess, setRevSuccess] = useState([])
    const [revMissing, setRevMissing] = useState([])
    const [flows, setFlows] = useState([])
    //const [mobileFlows, setMobileFlows] = useState([])
    //const [lpStats, setLpStats] = useState([])
    const [pids, setPids] = useState([])
    const [geos, setGeos] = useState([])
    //const [paths, setPaths] = useState([])

    //filters
    const [startDate, setStartDate] = useState(new Date(Moment().add(-1, 'days').format('MM/DD/YYYY')))
    const [endDate, setEndDate] = useState(new Date(Moment().format('MM/DD/YYYY')))
    const [curPid, setCurPid] = useState('')
    const [curGeo, setCurGeo] = useState('')
    const [curDevice, setCurDevice] = useState('')
    const [curGender, setCurGender] = useState('')
    const [curAnswer, setCurAnswer] = useState(0)
    const [groupBy, setGroupBy] = useState('')
    //const [curBoosts, setCurBoosts] = useState([])
    //const [curPath, setCurPath] = useState(0)
    //const [boostHours, setBoostHours] = useState(2)
    //const [boostPid, setBoostPid] = useState('')
    //const [formMessage, setFormMessage] = useState('')

    const tableFields = ["Path", "Total Requests", "Success #", "Failure #", "Success %", "Fail %", "Paid #", "Paid %", "Rev/Paid Lead", "Revenue", "Rev/Lead", "Sales", "CPS", "Revshares", "RS Revenue"]
    const tableFieldName = ["path", "total_requests", "success_count", "failure_count", "success_rate_percent", "failure_rate_percent", "paid_count", "paid_percent", "avg_rev", "tot_revenue", "avg_rev_lead", "tot_sales", "cps", "tot_revshare", "revshare_revenue"]
    const flowFields = ["Path", "Priority"]
    const revFields = ["Path", "Revenue"]

    const q1Answers = [
        {'ID': 0, 'NAME': 'VIEW ALL TYPES'},
        {'ID': 1, 'NAME': 'Random Hookup'},
        {'ID': 3, 'NAME': 'Discreet Affairs'},
        {'ID': 4, 'NAME': 'Friend w/Benefits'},
        {'ID': 5, 'NAME': 'Casual Dating'},
        {'ID': 9, 'NAME': 'Girlfriend Experience'},
    ]
    const genders = [
        {'ID': '', 'NAME': 'VIEW ALL TYPES'},
        {'ID': 'male', 'NAME': 'Male'},
        {'ID': 'female', 'NAME': 'Female'},
    ];

    const [sortField, setSortField] = useState('total_requests')
    const [sortDirection, setSortDirection] = useState(1)

    //const boostFields = ["Path", "Subpid", "End Date"]
    //const successFields = ["Path", "Success #", "Total #", "Success %"]

    const [revCsvStatus, setRevCsvStatus] = useState(0)
    const [revCsv, setRevCsv] = useState({})

    const [regCsvStatus, setRegCsvStatus] = useState(0)
    const [regCsv, setRegCsv] = useState({})

    const [runStatus, setRunStatus] = useState(1)

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                setRunStatus(2)
                const data = await toolsAPICall(tool_lp_dashboard_stats, { 'requester': userID, 'company': companyID, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'gender': curGender, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType, 'groupBy': groupBy })
                setRevStats(data.revstats)
                //setRevSuccess(data.revsuccess)
                if(data.missedrev) setRevMissing(data.missedrev)
                setRevCsv({})
                setRevCsvStatus(0)
                setRegCsv({})
                setRegCsvStatus(0)
                //setLpStats(data.lpstats)
                setFlows(data.paths)
                //setMobileFlows(data.flows)
                if(data.pids) setPids(sortPids(data.pids))
                if(data.geos) setGeos(data.geos)
                //if(data.boosts) setCurBoosts(data.boosts)
                //if(data.paths) setPaths(data.paths)
                if(parseInt(cascadeType) === 0) {
                    const bldata = await toolsAPICall(tool_lp_dashboard_stats, { 'requester': userID, 'company': companyID, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': 4, 'groupBy': groupBy })
                    setBlacklistStats(bldata.revstats)   
                }
                
                setRunStatus(0)
            }
        }
        if(runStatus === 1) {
            getStats()
        }
    }, [userID, companyID, curPid, curGeo, curDevice, curAnswer, curGender, startDate, endDate, cascadeType, groupBy, runStatus])
    

    const genRevReport = async (e) => {
        e.preventDefault()
        setRevCsvStatus(1)
        const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 1, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'gender': curGender, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType, 'groupBy': groupBy })
        if(csvData.revcsv) { 
            setRevCsv(csvData.revcsv)
            setRevCsvStatus(2)
        }
    }

    const genRegReport = async (e) => {
        e.preventDefault()
        setRegCsvStatus(1)
        const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 2, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'gender': curGender, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType, 'groupBy': groupBy })
        if(csvData.revcsv) { 
            setRegCsv(csvData.revcsv)
            setRegCsvStatus(2)
        }
    }

    /*
    const postBoost = async (e) => {
        e.preventDefault()
        setFormMessage("")

        if(!curPath) {
            setFormMessage("Please select a Path")
            return
        }
        if(!boostHours) {
            setFormMessage("Please enter hours to boost")
            return
        }

        const data = await toolsAPICall(tool_lp_dashboard_boost, {
            'requester': userID, 
            'company': companyID, 
            'pathid': curPath,
            'subpid': boostPid,
            'hours': boostHours
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setFormMessage(data.error)
            return
        } 

        setFormMessage("Path boosted. Boosting will start at the top of the hour.")
        if(data.boosts) {
            setCurBoosts(data.boosts)
        }
    }
*/

    const tableData = (type) => {
        let values = []
        if(type === 1) {
            if(!revStats || revStats.length === 0) {
                return values;
            } else {
                values = revStats
            }
        }
        else if(type === 2) {
            if(!revMissing || revMissing.length === 0) {
                return values;
            } else {
                values = revMissing
            }
        }
        else if(type === 3) {
            if(!blacklistStats || blacklistStats.length === 0) {
                return values;
            } else {
                values = blacklistStats
            }
        }
        return buildRows(values)
    }

    // When grouped by geo, revstats is [{geo, rows}, ...]; return that list, else wrap the flat list
    const tableGroups = (type) => {
        let values = type === 1 ? revStats : type === 3 ? blacklistStats : []
        if(!values || values.length === 0) return []
        if(values[0] && values[0].rows !== undefined) {
            return values.map(g => ({ geo: g.geo, rows: buildRows(g.rows) }))
        }
        return [{ geo: '', rows: buildRows(values) }]
    }

    const buildRows = (values) => {
        if(!values || values.length === 0) return []

        // Sort values before mapping
        values = [...values].sort((a, b) => {
            // Always move "TOTAL" to the bottom
            if (a.path === "TOTAL") return 1;
            if (b.path === "TOTAL") return -1;

            let aValue = a[sortField];
            let bValue = b[sortField];

            // Convert to number if field is numeric
            if (['total_requests','success_count','failure_count','paid_count','tot_sales','tot_revshare'].includes(sortField)) {
                aValue = parseInt(aValue);
                bValue = parseInt(bValue);
            } else if (['success_rate_percent','failure_rate_percent','paid_percent','tot_revenue','avg_rev','avg_rev_lead','cps','revshare_revenue'].includes(sortField)) {
                aValue = parseFloat(aValue);
                bValue = parseFloat(bValue);
            } else {
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();
            }

            if (aValue < bValue) return sortDirection === 0 ? -1 : 1;
            if (aValue > bValue) return sortDirection === 0 ? 1 : -1;
            return 0;
        });

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.path, 'values': [
                row.path,
                row.total_requests,
                row.success_count,
                row.failure_count,
                row.success_rate_percent + '%',
                row.failure_rate_percent + '%',
                row.paid_count,
                row.paid_percent + '%',
                row.avg_rev ? '$' + parseFloat(row.avg_rev).toFixed(4) : '',
                '$' + row.tot_revenue,
                row.avg_rev_lead ? '$' + parseFloat(row.avg_rev_lead).toFixed(4) : '',
                row.tot_sales,
                '$' + row.cps,
                row.tot_revshare ?? 0,
                '$' + parseFloat(row.revshare_revenue || 0).toFixed(2),
            ]});
        });
        return rows
    }

    const sortData = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortField(tableFieldName[index])
        setSortDirection(direction)
    }

    /*
    const successData = () => {
        if(!revSuccess || revSuccess.length === 0) {
            return [];
        } 

        let values = revSuccess

        let rows = [];
        values.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': row.offer, 'values': [
                    row.offer,
                    row.success,
                    row.total,
                    parseFloat(row.success_rate).toFixed(2) + '%'
                ]});
            //}
        });
        return rows
    }
    */

    const flowData = (type) => {
        if(!flows || flows.length === 0) {
            return [];
        } 

        let values = type === 1 ? flows : []
        let idstr = type === 1 ? "D" : "M"
        let rows = [];
        let rowid = 0;
        values.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': `${idstr}_${rowid}`, 'values': [
                    row.path,
                    row.order
                ]});
                rowid++;
            //}
        });
        return rows
    }

    /*
    const boostData = () => {
        if(!curBoosts || curBoosts.length === 0) {
            return [];
        } 

        let rows = [];
        curBoosts.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': `B_${row.boostid}`, 'values': [
                    row.path,
                    row.subpid,
                    row.boost_end
                ]});
            //}
        });
        return rows
    }
    */
    const runFilter = async () => {
        setRevCsv({}); setRevCsvStatus(0);
        setRegCsv({}); setRegCsvStatus(0);
      
        setFlows([]); setRevStats([]); setRevMissing([]);
      
        setRunStatus(1)
      };
      

    const filterDate = (field, value) => {
        if(field === 1) setStartDate(value)
        else if(field === 2) setEndDate(value)
    }

    const filterCascade = (e) => {
        let { value } = e.target;
        setCascadeType(value)
    }
    const filterPid = (e) => {
        let { value } = e.target;
        setCurPid(value)
    }
    const filterGeo = (e) => {
        let { value } = e.target;
        setCurGeo(value)
    }
    const filterGroupBy = (e) => {
        let { value } = e.target;
        setGroupBy(value)
    }
    const filterDevice = (e) => {
        let { value } = e.target;
        setCurDevice(value)
    }
    const filterAnswer = (e) => {
        let { value } = e.target;
        setCurAnswer(value)
    }
    const filterGender = (e) => {
        let { value } = e.target;
        setCurGender(value)
    }
    /*
    const setPath = (e) => {
        let { value } = e.target;
        setCurPath(value)
    }
    */

    if(!tool) return <></>

    if(!pids) return <>No Data</>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <CascadeToolToggle title={tool.tool_name} description={tool.description} value={cascadeType} onChange={filterCascade} />
                <Form description={tool.description} noCard={true} >
                    <Row>
                        <Col md={6}>
                            <strong>Dates</strong>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={startDate}>Start Date</FormLabel>
                                <Col md={6}>
                                    <DatePicker id="startDate" name="startDate" selected={startDate} className="form-control" onChange={(date) => filterDate(1, date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={endDate}>End Date</FormLabel>
                                <Col md={6}>
                                <DatePicker id="endDate" name="endDate" selected={endDate} className="form-control" onChange={(date) => filterDate(2, date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <strong>Filters</strong>
                    {pids.length === 0 ? "" :
                    <Select
                        value={curPid}
                        label="SUBPID"
                        name="pid"
                        formValues={pids}
                        useDefault={false}
                        onChange={filterPid}
                        validate="string"
                        colSize="6"
                    />}
                    {geos.length === 0 ? "" :
                    <Select
                        value={curGeo}
                        label="GEOS"
                        name="geo"
                        formValues={geos}
                        useDefault={false}
                        onChange={filterGeo}
                        validate="string"
                        colSize="6"
                    />}
                    <Select
                        value={groupBy}
                        label="DISPLAY"
                        name="groupBy"
                        formValues={[{'ID': "", 'NAME': "All Geos Totalled"}, {'ID': "geo", 'NAME': "Separated By Geo"}]}
                        useDefault={false}
                        onChange={filterGroupBy}
                        validate="string"
                        colSize="6"
                    />
                    <Select
                        value={curDevice}
                        label="DEVICES"
                        name="device"
                        formValues={[{'ID': "", 'NAME': "VIEW ALL DEVICES"}, {'ID': "mobile", 'NAME': "Mobile"}, {'ID': "desktop", 'NAME': "Desktop"}]}
                        useDefault={false}
                        onChange={filterDevice}
                        validate="string"
                        colSize="6"
                    />
                    <Select
                        value={curGender}
                        label="GENDER"
                        name="gender"
                        formValues={genders}
                        useDefault={false}
                        onChange={filterGender}
                        validate="string"
                        colSize="6"
                    />
                    <Select
                        value={curAnswer}
                        label="RELATIONSHIP TYPE"
                        name="answer"
                        formValues={q1Answers}
                        useDefault={false}
                        onChange={filterAnswer}
                        validate="number"
                        colSize="6"
                    />
                    </Col>
                    </Row>
                        {runStatus === 2 && <Card.Body>Loading Dashboard...</Card.Body> }
                        {runStatus === 0 && <>
                    <Row>
                        <Col md={12} className='text-center'>
                            <Button onClick={(e) => { e.preventDefault(); runFilter(); }} title="Filter Dashboard" className="primary" /> 
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                        {tableGroups(1).length === 0 && <>
                            <CardHeader title="Offer Success" description="" />
                            <DataTable hover={false} tableID="suc" fieldNames={tableFields} dataRows={[]} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Total Requests' />
                        </>}
                        {tableGroups(1).map((g, i) => <React.Fragment key={`suc_${g.geo || i}`}>
                            <CardHeader title={g.geo ? `Offer Success - ${g.geo}` : "Offer Success"} description="" />
                            <DataTable hover={false} tableID={`suc_${i}`} fieldNames={tableFields} dataRows={g.rows} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Total Requests' />
                        </React.Fragment>)}
                        
                        <p align="center">
                        { revCsvStatus === 0 && // default
                            <Button title="Generate Revenue Report" className="secondary" onClick={genRevReport} /> }
                        { revCsvStatus === 1 && // generating has begun
                            <small>Generating Report...</small> }
                        { revCsvStatus === 2 && revCsv.file && // download now available
                        <CSVLink 
                        data={revCsv.data}
                        filename={revCsv.file}
                        className="btn btn-primary text-center"
                        target="_blank">Export Revenue Data</CSVLink>}

                        { regCsvStatus === 0 && // default
                            <Button title="Generate RegData Report" className="secondary" onClick={genRegReport} /> }
                        { regCsvStatus === 1 && // generating has begun
                            <small>Generating Report...</small> }
                        { regCsvStatus === 2 && regCsv.file && // download now available
                        <CSVLink 
                        data={regCsv.data}
                        filename={regCsv.file}
                        className="btn btn-primary text-center ml-2"
                        target="_blank">Export RegData</CSVLink>}  
                        </p>
                        </Col>

                        {tableGroups(3).length === 0 && <>
                            <CardHeader title="Blacklist Success" description="" />
                            <DataTable hover={false} tableID="bl" fieldNames={tableFields} dataRows={[]} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Total Requests' />
                        </>}
                        {tableGroups(3).map((g, i) => <React.Fragment key={`bl_${g.geo || i}`}>
                            <CardHeader title={g.geo ? `Blacklist Success - ${g.geo}` : "Blacklist Success"} description="" />
                            <DataTable hover={false} tableID={`bl_${i}`} fieldNames={tableFields} dataRows={g.rows} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Total Requests' />
                        </React.Fragment>)}
                        
                    </Row>
                    <Row>
                        <Col md={6}>
                            <CardHeader title="Flows" description="Default flows for the subpid/geo/device selection" />
                            <DataTable hover={false} tableID="flow" fieldNames={flowFields} dataRows={flowData(1)} tableSettings={tableTypes.None} hideTotal={true} />
                        </Col>
                        <Col md={6}>
                            <CardHeader title="Unaccounted Revenue - Offers" description="Received Revenue with no matching registration" />
                            <DataTable hover={false} tableID="rpmiss" fieldNames={revFields} dataRows={tableData(2)} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        </Col>
                        {/*
                        <CardHeader title="Offer Success Rates" description="" />
                        <DataTable hover={false} tableID="success" fieldNames={successFields} dataRows={successData()} tableSettings={tableTypes.None} hideTotal={true} />
                        </Col>
                        <Col md={6}>
                            <CardHeader title="Desktop Flow Paths" description="Desktop Flows" />
                            { flows && flows.length > 0 ? 
                            <DataTable hover={false} tableID="flow" fieldNames={flowFields} dataRows={flowData(1)} tableSettings={tableTypes.None} hideTotal={true} />
                            : <Row><Col md={12} className='ml-4'>No Flow Paths available for this Cascade</Col></Row>
                            }
                            
                            <CardHeader title="Mobile Flow Paths" description="Mobile Flows" />
                            { flows && flows.length > 0 ? 
                            <DataTable hover={false} tableID="mflow" fieldNames={flowFields} dataRows={flowData(2)} tableSettings={tableTypes.None} hideTotal={true} />
                            : <Row><Col md={12} className='ml-4'>No Flow Paths available for this Cascade</Col></Row>
                            }
                        </Col>
                        */}
                        
                    </Row>
                    </> }
                </Form>
                </Card>
                {/*
                <Form title="Path Boosting" description="Use the following tool to temporarily boost traffic for a Path. During their boost window they will receive 100% of the first cascade traffic (after AFF Coreg)." onSubmit={postBoost}>

                    <Row className='mt-4'>
                        <Col md={6}>
                        <strong>Schedule New Boost</strong><br/><br/>
                            {paths.length === 0 ? "" :
                            <Select
                                value={curPath}
                                label="PATH"
                                name="curPath"
                                formValues={paths}
                                useDefault={true}
                                onChange={setPath}
                                validate="number"
                                colSize="6"
                            />}
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={boostPid}>Subpid</FormLabel>
                                <Col md={6}>
                                <input id="boostPid" name="boostPid" type='text' value={boostPid} placeholder='Subpid' className="form-control" onChange={(e) => setBoostPid(e.target.value)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={boostHours}>Hours to Boost</FormLabel>
                                <Col md={6}>
                                <input id="boostHours" name="boostHours" type='number' value={boostHours} className="form-control" onChange={(e) => setBoostHours(e.target.value)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <Col md={9} className="text-center">
                                    <Card.Text>{formMessage}</Card.Text>
                                    <Button title="Boost!" className="info" />
                                </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                        <strong>Active Boosts</strong>
                        <DataTable hover={false} tableID="boosts" fieldNames={boostFields} dataRows={boostData()} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        </Col>
                    </Row>
                </Form>
                */}
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(LanderDashboard), "Cascade Dashboard"));